"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.symbol.async-iterator");
require("core-js/modules/es6.symbol");
require("core-js/modules/es6.array.from");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.regexp.split");
var _slicedToArray2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js"));
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.set");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/web.dom.iterable");
var _toConsumableArray2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
var _RegionStorePane = _interopRequireDefault(require("../RegionStorePane"));
var _goods_activity_combo = require("@/api/goods_activity/goods_activity_combo");
var _referral_purchase = require("@/api/goods_activity/referral_purchase");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ReferralPurchaseEdit',
  // 推荐购编辑
  components: {
    RegionStorePane: _RegionStorePane.default
  },
  props: {
    referralFnId: {
      type: String,
      default: ''
    } // 推荐购ID
  },
  data: function data() {
    return {
      menuTypeList: [],
      // 点餐类型列表
      loading: false,
      form: {
        activityName: '',
        // 活动名称
        menuTypes: [],
        // 点餐类型
        executeCycle: 'weekly',
        // 执行周期
        daysOfWeekList: [],
        // 周期执行：[1, 2, 3, 4, 5，6，7] (代表周一到周日)
        executeDateList: [],
        // 执行日期
        executeTimeList: ['09:00', '23:00'],
        // 执行时间
        markForEnable: true,
        // 是否启用
        storeScope: 0,
        // 店铺范围
        checkedReferralGoodsList: [],
        // 关联商品ID
        checkedSuggestGoodsList: [],
        // 推荐商品ID
        relatedStoreIdList: [] // 指定门店ID
      },
      regionStoreList: [],
      // 指定区域门店
      searchGoodsLoading: false,
      referralGoodsTableKey: 0,
      // 关联商品表格key
      referralGoods: {},
      // 关联商品
      relatedGoodsList: [],
      // 推荐商品列表
      goodsTableKey: 0,
      // 商品表格key
      suggestGoods: {},
      // 搜索推荐商品
      suggestGoodsList: [],
      // 推荐商品列表
      searchSuggestGoodsLoading: false
    };
  },
  created: function created() {
    this.getMenuType();
    this.queryRegionStoreList();
    if (this.referralFnId) {
      this.getReferralPurchaseDetail();
    }
  },
  methods: {
    getReferralPurchaseDetail: function getReferralPurchaseDetail() {
      var _this = this;
      (0, _referral_purchase.referralPurchaseDetail)(this.referralFnId).then(function (res) {
        var data = res.data;
        console.log('=== 后端返回的原始数据 ===', JSON.stringify(data, null, 2));
        if (data) {
          _this.form.activityName = data.xyGaReferral && data.xyGaReferral.activityName || '';
          _this.form.menuTypes = data.menuTypes || [];
          _this.form.executeCycle = data.xyGaReferral && data.xyGaReferral.executeCycle || 'weekly';
          _this.form.daysOfWeekList = data.daysOfWeekList || [];
          _this.form.markForEnable = data.xyGaReferral && data.xyGaReferral.markForEnable !== undefined ? data.xyGaReferral.markForEnable : true;
          _this.form.storeScope = data.xyGaReferral && data.xyGaReferral.storeScope !== undefined ? data.xyGaReferral.storeScope : 0;
          _this.form.checkedReferralGoodsList = data.checkedReferralGoodsList || [];
          _this.form.relatedStoreIdList = data.relatedStoreIdList || [];

          // 处理活动时间范围：优先使用数组格式
          if (data.executeDateList && data.executeDateList.length > 0) {
            _this.form.executeDateList = (0, _toConsumableArray2.default)(data.executeDateList);
            console.log('活动时间范围(直接使用数组):', _this.form.executeDateList);
          } else if (data.xyGaReferral && data.xyGaReferral.startDate && data.xyGaReferral.endDate) {
            // 从分离字段转换为数组
            _this.form.executeDateList = [data.xyGaReferral.startDate, data.xyGaReferral.endDate];
            console.log('活动时间范围(从字段转换):', _this.form.executeDateList);
          } else if (data.xyGaReferral && data.xyGaReferral.startDateStr && data.xyGaReferral.endDateStr) {
            _this.form.executeDateList = [data.xyGaReferral.startDateStr, data.xyGaReferral.endDateStr];
            console.log('活动时间范围(从Str字段转换):', _this.form.executeDateList);
          } else {
            _this.form.executeDateList = [];
            console.log('活动时间范围(空):', _this.form.executeDateList);
          }

          // 处理执行时间：优先使用数组格式，否则从分钟数转换
          if (data.executeTimeList && data.executeTimeList.length > 0) {
            _this.form.executeTimeList = (0, _toConsumableArray2.default)(data.executeTimeList);
            console.log('执行时间(直接使用数组):', _this.form.executeTimeList);
          } else if (data.xyGaReferral && data.xyGaReferral.startTime !== undefined && data.xyGaReferral.endTime !== undefined) {
            // 后端返回的是分钟数，需要转换为时间字符串
            _this.form.executeTimeList = [_this.minutesToTime(data.xyGaReferral.startTime), _this.minutesToTime(data.xyGaReferral.endTime)];
            console.log('执行时间(从分钟数转换):', _this.form.executeTimeList, "(\u539F\u59CB: ".concat(data.xyGaReferral.startTime, " - ").concat(data.xyGaReferral.endTime, ")"));
          } else {
            _this.form.executeTimeList = ['09:00', '23:00'];
            console.log('执行时间(默认值):', _this.form.executeTimeList);
          }

          // 确保推荐商品的 activityPrice 字段存在
          _this.form.checkedSuggestGoodsList = (data.checkedSuggestGoodsList || []).map(function (item) {
            if (item.activityPrice === undefined || item.activityPrice === null) {
              _this.$set(item, 'activityPrice', 0);
            }
            return item;
          });
          console.log('=== 表单数据最终状态 ===');
          console.log('活动名称:', _this.form.activityName);
          console.log('活动时间范围:', _this.form.executeDateList);
          console.log('执行时间:', _this.form.executeTimeList);
          console.log('执行周期:', _this.form.executeCycle);
          console.log('星期:', _this.form.daysOfWeekList);
        }
      });
    },
    submitForm: function submitForm() {
      var _this2 = this;
      // 确保所有推荐商品都有 activityPrice 字段
      this.form.checkedSuggestGoodsList.forEach(function (item, index) {
        if (item.activityPrice === undefined || item.activityPrice === null) {
          item.activityPrice = 0;
        }
      });

      // 准备提交数据
      var submitData = _objectSpread({}, this.form);

      // 处理活动时间范围：后端同时需要数组格式和分离字段
      if (this.form.executeDateList && this.form.executeDateList.length === 2) {
        // 保留数组格式
        submitData.executeDateList = (0, _toConsumableArray2.default)(this.form.executeDateList);
        // 添加分离字段
        submitData.startDate = this.form.executeDateList[0];
        submitData.endDate = this.form.executeDateList[1];
      }

      // 处理执行时间：后端同时需要数组格式和分离字段
      if (this.form.executeTimeList && this.form.executeTimeList.length === 2) {
        // 保留数组格式
        submitData.executeTimeList = (0, _toConsumableArray2.default)(this.form.executeTimeList);
        // 添加分离字段（转换为分钟数）
        submitData.startTime = this.timeToMinutes(this.form.executeTimeList[0]);
        submitData.endTime = this.timeToMinutes(this.form.executeTimeList[1]);
      }
      console.log('=== 提交数据 ===');
      console.log('活动时间范围数组:', submitData.executeDateList);
      console.log('活动时间范围字段:', submitData.startDate, '-', submitData.endDate);
      console.log('执行时间数组:', submitData.executeTimeList);
      console.log('执行时间字段(分钟):', submitData.startTime, '-', submitData.endTime);
      console.log('完整数据:', JSON.stringify(submitData, null, 2));
      this.loading = true;
      if (this.referralFnId) {
        // 编辑
        var editData = _objectSpread(_objectSpread({}, submitData), {}, {
          fnId: this.referralFnId
        });
        (0, _referral_purchase.referralPurchaseEdit)(editData).then(function (res) {
          _this2.$message.success(res.message);
          _this2.loading = false;
          _this2.$emit('success');
        }, function (error) {
          console.error('编辑失败:', error);
          _this2.loading = false;
        });
      } else {
        // 新建
        (0, _referral_purchase.referralPurchaseSave)(submitData).then(function (res) {
          _this2.$message.success(res.message);
          _this2.loading = false;
          _this2.$emit('success');
        }, function (error) {
          console.error('新建失败:', error);
          _this2.loading = false;
        });
      }
    },
    handleRegionStoreChange: function handleRegionStoreChange(val) {
      // 重新收集所有区域的选中门店ID
      var allCheckedStoreIds = [];
      if (this.$refs) {
        // 遍历所有 RegionStorePane 组件，收集每个区域选中的门店
        var _iterator = _createForOfIteratorHelper(this.regionStoreList),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var regionStore = _step.value;
            var refKey = 'regionStorePane_' + regionStore.regionId;
            var paneRef = this.$refs[refKey];
            if (paneRef && paneRef.length > 0) {
              var checkedIds = paneRef[0].getCheckedStoreIds();
              if (checkedIds && checkedIds.length > 0) {
                allCheckedStoreIds.push.apply(allCheckedStoreIds, (0, _toConsumableArray2.default)(checkedIds));
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      // 去重并更新
      this.form.relatedStoreIdList = (0, _toConsumableArray2.default)(new Set(allCheckedStoreIds));
      console.log('当前选中门店:', this.form.relatedStoreIdList);
    },
    handleStoreScopeChange: function handleStoreScopeChange(val) {
      // 当切换门店范围时，清空或重置 relatedStoreIdList
      if (val === 0) {
        // 切换到全部门店，清空指定门店列表
        this.form.relatedStoreIdList = [];
      }
      // 如果是切换到指定门店(val === 1)，保持 relatedStoreIdList 为空，
      // 等待用户通过 handleRegionStoreChange 添加门店
    },
    removeReferraltGoods: function removeReferraltGoods(item) {
      var index = -1;
      for (var i = 0; i < this.form.checkedReferralGoodsList.length; i++) {
        var referralGoods = this.form.checkedReferralGoodsList[i];
        if (item.goodsFnId === referralGoods.goodsFnId) {
          index = i;
          break;
        }
      }
      if (index !== -1) {
        this.form.checkedReferralGoodsList.splice(index, 1);
      }
    },
    addReferralGoods: function addReferralGoods() {
      var exist = false;
      if (this.referralGoods && this.referralGoods.goodsFnId) {
        for (var i = 0; i < this.form.checkedReferralGoodsList.length; i++) {
          var referralGoods = this.form.checkedReferralGoodsList[i];
          if (this.referralGoods.goodsFnId === referralGoods.goodsFnId) {
            exist = true;
            break;
          }
        }
        if (!exist) {
          this.form.checkedReferralGoodsList.push(this.referralGoods);
        }
        this.referralGoods = {};
      }
    },
    removeSuggestGoods: function removeSuggestGoods(item) {
      var index = -1;
      for (var i = 0; i < this.form.checkedSuggestGoodsList.length; i++) {
        var suggestGoods = this.form.checkedSuggestGoodsList[i];
        if (item.goodsFnId === suggestGoods.goodsFnId && item.unitFnId === suggestGoods.unitFnId) {
          index = i;
          break;
        }
      }
      if (index !== -1) {
        this.form.checkedSuggestGoodsList.splice(index, 1);
      }
    },
    addSuggestGoods: function addSuggestGoods() {
      var exist = false;
      if (this.suggestGoods && this.suggestGoods.goodsFnId && this.suggestGoods.unitFnId) {
        for (var i = 0; i < this.form.checkedSuggestGoodsList.length; i++) {
          var item = this.form.checkedSuggestGoodsList[i];
          if (item.goodsFnId === this.suggestGoods.goodsFnId && item.unitFnId === this.suggestGoods.unitFnId) {
            exist = true;
            break;
          }
        }
        if (!exist) {
          this.suggestGoods.sorts = this.form.checkedSuggestGoodsList.length + 1;
          // 自动带入商品原价到活动价格
          if (this.suggestGoods.goodsPrice !== undefined && this.suggestGoods.goodsPrice !== null) {
            this.$set(this.suggestGoods, 'activityPrice', this.suggestGoods.goodsPrice);
          } else {
            this.$set(this.suggestGoods, 'activityPrice', 0);
          }
          this.form.checkedSuggestGoodsList.push(this.suggestGoods);
        }
      }
      this.suggestGoods = {};
    },
    searchSuggestGoods: function searchSuggestGoods(query) {
      var _this3 = this;
      this.searchSuggestGoodsLoading = true;
      (0, _goods_activity_combo.queryGoodsAndSpecSearch)({
        keywords: query
      }).then(function (res) {
        var data = res.data;
        if (data) {
          _this3.suggestGoodsList = data.goodsList || [];
          _this3.searchSuggestGoodsLoading = false;
        }
      }, function () {
        _this3.searchSuggestGoodsLoading = false;
      });
    },
    searchGoods: function searchGoods(query) {
      var _this4 = this;
      this.searchGoodsLoading = true;
      (0, _goods_activity_combo.queryGoodsSearch)({
        keywords: query
      }).then(function (res) {
        var data = res.data;
        if (data) {
          _this4.relatedGoodsList = data.goodsList || [];
          _this4.searchGoodsLoading = false;
        }
      }, function () {
        _this4.searchGoodsLoading = false;
      });
    },
    queryRegionStoreList: function queryRegionStoreList() {
      var _this5 = this;
      (0, _goods_activity_combo.queryRegionStoreList)().then(function (res) {
        var data = res.data;
        if (data) {
          _this5.regionStoreList = data.storeRegions || [];
        }
      });
    },
    getMenuType: function getMenuType() {
      var _this6 = this;
      (0, _goods_activity_combo.queryMenuType)().then(function (res) {
        var data = res.data;
        if (data) {
          _this6.menuTypeList = data.records || [];
        }
      });
    },
    handleSuggestGoodsPriceChange: function handleSuggestGoodsPriceChange(row) {
      // 确保价格变化时数据被正确追踪
      this.$forceUpdate();
    },
    /**
     * 将时间字符串(HH:mm)转换为分钟数
     * @param {String} timeStr - 时间字符串，如 "09:00"
     * @returns {Number} 分钟数，如 540
     */
    timeToMinutes: function timeToMinutes(timeStr) {
      if (!timeStr) return 0;
      var _timeStr$split$map = timeStr.split(':').map(Number),
        _timeStr$split$map2 = (0, _slicedToArray2.default)(_timeStr$split$map, 2),
        hours = _timeStr$split$map2[0],
        minutes = _timeStr$split$map2[1];
      return hours * 60 + minutes;
    },
    /**
     * 将分钟数转换为时间字符串(HH:mm)
     * @param {Number} minutes - 分钟数，如 540
     * @returns {String} 时间字符串，如 "09:00"
     */
    minutesToTime: function minutesToTime(minutes) {
      if (!minutes && minutes !== 0) return '09:00';
      var hours = Math.floor(minutes / 60);
      var mins = minutes % 60;
      return "".concat(String(hours).padStart(2, '0'), ":").concat(String(mins).padStart(2, '0'));
    }
  }
};